var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vault_svg__clip0_5429_56686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5C0 12.747 0 7.87 2.646 4.555a12.111 12.111 0 011.91-1.909C7.87 0 12.745 0 22.5 0c9.753 0 14.63 0 17.945 2.646a12.108 12.108 0 011.909 1.91C45 7.87 45 12.745 45 22.5c0 9.753 0 14.63-2.646 17.945a12.104 12.104 0 01-1.91 1.909C37.13 45 32.255 45 22.5 45c-9.753 0-14.63 0-17.945-2.646a12.108 12.108 0 01-1.909-1.91C0 37.13 0 32.255 0 22.5z",
    fill: "url(#vault_svg__paint0_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 19.296c.499-7.018-1.303-10.527-5.406-10.527s-5.905 3.508-5.406 10.527h-2.96c-.772-9.061 2.017-13.592 8.366-13.592 6.35 0 9.138 4.53 8.366 13.591h-2.96z",
    fill: "url(#vault_svg__paint1_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.577 33.136l-.064-.067-.127-.135-.063-.067-.125-.135c-1.015-1.108-1.886-2.318-2.067-4.904-.057-.8-.086-1.935-.089-3.405v-.484c.003-1.541.032-3.417.089-5.628l10.982-2.523 10.983 2.523c.057 2.21.086 4.087.089 5.628v.484c-.003 1.47-.032 2.605-.089 3.405-.181 2.586-1.052 3.796-2.067 4.904l-.125.135-.063.067-.127.135-.064.067c-1.532 1.619-4.378 3.253-8.537 4.902-4.158-1.65-7.004-3.283-8.536-4.902z",
    fill: "#4F3292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.488 14.802c-.068-4.092-1.864-6.138-5.386-6.138-3.521 0-5.31 2.046-5.363 6.138.602-3.636 2.39-5.454 5.363-5.454 2.974 0 4.77 1.818 5.386 5.454z",
    fill: "url(#vault_svg__paint2_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.577 32.282l-.194-.196-.128-.13c-1.04-1.07-1.94-2.217-2.125-4.721-.056-.76-.085-1.836-.088-3.23v-.476c.003-1.464.033-3.244.088-5.342l10.983-2.399 10.983 2.399c.057 2.098.086 3.878.089 5.342v.477c-.003 1.393-.032 2.47-.089 3.229-.184 2.504-1.085 3.651-2.124 4.72l-.128.131-.194.196c-1.532 1.539-4.378 3.092-8.537 4.66-4.158-1.568-7.004-3.121-8.536-4.66z",
    fill: "url(#vault_svg__paint3_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.113 15.788l10.983 2.399c.119 4.428.119 7.444 0 9.048-.204 2.76-1.276 3.871-2.446 5.047-1.532 1.539-4.378 3.092-8.537 4.66V15.788z",
    fill: "url(#vault_svg__paint4_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.06 15.788v1.756l-11.018 2.264.031-1.625 10.988-2.395z",
    fill: "url(#vault_svg__paint5_linear_5429_56686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.113 15.788v1.751l11.022 2.268-.036-1.622-10.986-2.397z",
    fill: "url(#vault_svg__paint6_linear_5429_56686)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint0_linear_5429_56686",
    x1: 45,
    y1: 0,
    x2: 0,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A1A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C66F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint1_linear_5429_56686",
    x1: 14.578,
    y1: -55.141,
    x2: 8.298,
    y2: 26.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#FBF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint2_linear_5429_56686",
    x1: 555.203,
    y1: -52.882,
    x2: 555.203,
    y2: 70.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint3_linear_5429_56686",
    x1: 12.993,
    y1: 14.578,
    x2: 22.817,
    y2: 35.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint4_linear_5429_56686",
    x1: 422.094,
    y1: 2131.18,
    x2: 1174.71,
    y2: 1314.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B27EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B482FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint5_linear_5429_56686",
    x1: 12.042,
    y1: 184.904,
    x2: 562.984,
    y2: 184.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vault_svg__paint6_linear_5429_56686",
    x1: 34.135,
    y1: 232.121,
    x2: -1035.32,
    y2: 30.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE92FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "vault_svg__clip0_5429_56686"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  })))));
}
export default SvgVault;